<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/frontendSetting/groupFitness')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="pt_name">Title</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="title" v-model="title" name="title" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('title') }}</span>
                </b-col>
              </b-row>
			  <b-row class="mb-20">
                <b-col sm="2">
                  <label for="link">Link</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="link" v-model="link" name="link" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('link') }}</span>
                </b-col>
              </b-row>              
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_pt">Image</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="file" v-validate="'required'" @change="previewImage" accept="image/*" v-model="file" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <div class="image-preview" v-if="imageData.length > 0">
                      <img class="preview" :src="imageData">
                  </div>
                  <span class="error">{{ errors.first('file') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { MultiSelect } from 'vue-search-select'

export default {
  name: 'editCoach',
  components: {
    MultiSelect
  },
  data: function () {
    return {
      title: '',
      imageData: '',
      file: null,
      link: '',
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('photos', this.file)
          data.append('title', this.title)
          data.append('link', this.link)
          axios.put('fitness/v1/frontend_groupfitness/'+(this.$route.params.id), data).then(response => {
            // console.log('test', response)
            this.$router.push('/frontendSetting/groupFitness')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('fitness/v1/frontend_groupfitness/' + (this.$route.params.id)).then(response => {
        this.title = response.data.data.title
        this.file = response.data.data.image
        this.imageData = Auth.apiUrl + 'fitness/v1/img/frontend/groupfitness/' + response.data.data.image
        this.link = response.data.data.link
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
